import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Form, FormGroup, Row, Col, Checkbox, ControlLabel, FormControl, Button} from 'react-bootstrap';
import {
    prepareSelectOptionsList,
    filterFocusAreaOptions,
    removePrefix,
    filterFocusAreaSelectedOptions
} from 'util/Utils';

import Select   from 'react-select'
import {
    makeRequest, reorderImages, updateRecord, displayMessage,
} from  'actions';
import {
    FETCH_ADMIN_PRODUCT,
    FETCH_FOCUS_AREAS,
    UPDATE_ADMIN_PRODUCT,
    FETCH_ALL_SELLERS_LIST
} from "actions/actionTypes";

import {getProduct} from 'reducers/reducer_admin_products';

import config from  '../../../config';
class AdminProductDetails extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        var selectedFocusAreas = _.isUndefined(this.props.product) ? [] : _.map(this.props.product.ProductTags, function (tag) {
            return {'value': tag, 'label': tag};
        })
        var ageGroupMap = _.isUndefined(this.props.product) ? [] : this.props.product.ProductAgeRange
        this.state = {
            focusAreasOptionsList: filterFocusAreaOptions(this.props.focusAreas.data, ageGroupMap),
            ProductTags: filterFocusAreaSelectedOptions(this.props.focusAreas.data, ageGroupMap, selectedFocusAreas),
            ProductAgeRange: ageGroupMap
        }

    }

    componentWillReceiveProps(nextProps) {
        if (_.size(nextProps.allSellersList.data) !== _.size(this.props.allSellersList.data)) {
            this.allSellersOptionsList = prepareSelectOptionsList(nextProps.allSellersList.data, {
                label: 'DisplayName',
                value: '_id'
            })
        }
        if (_.size(nextProps.focusAreas.data) !== _.size(this.props.focusAreas.data)) {
            var selectedFocusAreas = _.isUndefined(this.props.product) ? [] : _.map(this.props.product.ProductTags, function (tag) {
                return {'value': tag, 'label': tag};
            })
            this.setState({
                focusAreasOptionsList: filterFocusAreaOptions(nextProps.focusAreas.data, this.state.ProductAgeRange),
                ProductTags: filterFocusAreaSelectedOptions(nextProps.focusAreas.data, this.state.ProductAgeRange, selectedFocusAreas)
            })
        }
    }

    componentWillMount() {
        var self = this;
        var methodData = {
            "success_event": FETCH_ADMIN_PRODUCT,
            'endpoint': '/products/' + encodeURIComponent(this.props.params.product_id),
            'not_display_success_message': true,
        };
        this.props.makeRequest({}, methodData).then(res => {
            self.setState({
                focusAreasOptionsList: filterFocusAreaOptions(self.props.focusAreas.data, res.data.ProductAgeRange),
                ProductAgeRange: res.data.ProductAgeRange,
                ProductTags: _.map(res.data.ProductTags, function (tag) {
                    return {value: tag, label: tag};
                }),
            });
        }).catch(err => {
        });

        if (_.size(this.props.focusAreas.data) == 0) {
            var methodData = {
                "success_event": FETCH_FOCUS_AREAS,
                "endpoint": "/focus-areas",
                'not_display_success_message': true
            };
            this.props.makeRequest({}, methodData).catch(err => {
            });
        }

    }


    render() {
        console.log('this props edit product', this.state);
        if (!this.props.product) {
            return null
        }
        var product = this.props.product;


        console.log('seller',_.get(product.SellerID, ['0' ], '') );
        console.log('product', product);

        return (

            <div>
                <h4 className="left0">
                    Product details
                </h4>
                <Row>
                    <Col md={12} className="top20">
                        <div  className="bold-text">Title:</div>
                        <div> {product.ProductName}</div>
                    </Col>
                    <Col md={12} xs={12} className="top20">
                        <div  className="bold-text">Description:</div>
                        <div> {product.Description}</div>
                    </Col>

                    <Col md={12} xs={12} className="top20">
                        <div  className="bold-text">Price:</div>
                    </Col>
                </Row>
                <Row>
                    <Col md={5} xs={12} className="top20">
                        <ControlLabel>Age groups</ControlLabel>

                        <Select
                            tabIndex="0"
                            placeholder="Age group"

                            multi
                            value={this.state.ProductAgeRange}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={5} xs={12} className="top20">
                        <ControlLabel>Tags</ControlLabel>
                        <Select
                            tabIndex="0"
                            multi
                            selectedOptions
                            value={this.state.ProductTags}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={12} className="top20">
                        <div  className="bold-text">Condition:</div>
                        <div> {product.Condition}</div>
                    </Col>
                    <Col md={12} className="top20">
                        <div  className="bold-text">Status:</div>
                        <div> {product.Status}</div>
                    </Col>

                    <Col md={12} className="top20">
                        <div  className="bold-text">Seller display name:</div>
                        <div> {_.get(product.SellerID, [ 'DisplayName'], '')  }</div>
                    </Col>
                    <Col md={12} className="top20">
                        <div  className="bold-text">Seller email:</div>
                        <div> {  _.get(product.SellerID, [ 'UserID', 'email'], '')  }</div>
                    </Col>
                    <Col md={12} className="top20">
                        <div  className="bold-text">Seller name:</div>
                        <div> {  _.get(product.SellerID, [ 'UserID', 'firstName'], '') + ' ' + _.get(product.SellerID, [ 'UserID', 'lastName'], '')}</div>
                    </Col>
                    <Col md={12} className="top20">
                        <div  className="bold-text">Payout:</div>
                        <div> {product.Payout}</div>
                    </Col>

                    <Col md={12} className="top20">
                        <div  className="bold-text">Market:</div>
                        <div> {product.MarketName}</div>
                    </Col>
                    <Col md={12} className="top20">
                        <div  className="bold-text">Original Url:</div>
                        <div> {product.OriginalUrl}</div>
                    </Col>
                    <Col md={12} className="top20">
                        <div  className="bold-text">Original Description:</div>
                        <div> {product.OriginalDescription}</div>
                    </Col>
                    <Col md={12} className="top20">
                        <div  className="bold-text">Original Price:</div>
                        <div> {_.get(product, 'OriginalPrice','')}</div>
                    </Col>
                </Row>
            </div >
        );
    }
}

function mapStateToProps(state, props) {
    return {
        // seller: getSeller(state, props.params.id),
        focusAreas: state.focusAreas,
        allSellersList: state.allSellersList,
        product: getProduct(state, props.params.product_id),
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateRecord,
        makeRequest,
        reorderImages,
        displayMessage
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminProductDetails);
